import React from 'react';
import {
  Box,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { sanitizeDisplayText, splitLines } from '../lib/characterData';

function MultiLineValue({ value }) {
  const sanitized = sanitizeDisplayText(value);
  const lines = splitLines(value);

  if (lines.length === 0) {
    return <span>{sanitized || '-'}</span>;
  }

  return (
    <>
      {lines.map((line) => (
        <React.Fragment key={line}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </>
  );
}

const FIELDS = [
  ['名前', 'name'],
  ['二つ名', 'title'],
  ['実装日', 'implementation_date'],
  ['タイプ', 'role'],
  ['属性', 'element'],
  ['陣営', 'race'],
  ['所属', 'affiliation'],
  ['EXスキル1(Lv10)', 's1'],
  ['EXスキル2(Lv10)', 's2'],
  ['EXスキル1+(Lv10)', 's1_plus'],
  ['EXスキル2+(Lv10)', 's2_plus'],
  ['ユニークアビリティ', 'unique_ability'],
  ['固有スキル', 'unique_skill'],
  ['装飾品名', 'accessory_name'],
  ['装飾品アビリティ', 'accessory_effect'],
];

export default function CharacterDetailModal({ open, character, onClose }) {
  if (!character) {
    return null;
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '94%', md: '80%' },
          maxHeight: '85vh',
          overflow: 'auto',
          bgcolor: 'background.paper',
          p: 3,
          borderRadius: 2,
          boxShadow: 24,
          border: '1px solid rgba(255, 255, 255, 0.08)',
        }}
      >
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
        <Table size="small">
          <TableBody>
            {FIELDS.map(([label, key]) => (
              <TableRow key={key}>
                <TableCell sx={{ width: 180 }}>{label}</TableCell>
                <TableCell>
                  <MultiLineValue value={character[key]} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Modal>
  );
}
